import React from 'react';
import PropTypes from 'prop-types';
import { isGooglePdfPreview } from '@constants/config';
import GoogleFilePreview from '@shared/files/file-preview-display-google';
import ImagePreview from '@shared/files/file-preview-display-image';
import PdfFilePreview from '@shared/files/file-preview-display-pdf';
import './file-preview.scss';

const FilePreviewDisplay = ({ asset }) => {
  const renderDisplay = () => {
    const { file_content_type, file_name, signed_url } = asset;
    const mimeTypes = [
      'application/pdf', 'application/msword', 'image/x-dwg', 'text/csv', 'application/zip', 'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/octet-stream',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    // Google Docs Viewer intermittently answers with an empty application/binary
    // response that Chrome turns into a failed "gview" download, so PDFs use the
    // browser's own viewer unless the user opted back into Google's.
    if (file_content_type === 'application/pdf' && !isGooglePdfPreview()) {
      return <PdfFilePreview fileName={file_name} url={signed_url} />;
    }
    if (mimeTypes.includes(file_content_type)) {
      return <GoogleFilePreview url={signed_url} />;
    } else if (
      file_content_type === 'image/jpeg' || file_content_type === 'image/png'
    ) {
      return <ImagePreview fileName={file_name} url={signed_url} />;
    }
    return null;
  };

  return (
    <div styleName="file-preview-display">
      {renderDisplay()}
    </div>
  );
};

FilePreviewDisplay.propTypes = {
  asset: PropTypes.object
};

export default FilePreviewDisplay;
